import { StatModule } from "./StatModule";

export const statModules: StatModule[] = [];
